<template>
  <div class="vld-parent">
    <loading :active.sync="isLoading" loader="dots"
        :is-full-page="false" color="#0088cc"></loading>
    <div class="row">
      <div class="col-sm-9">
        <OnPlansNonDebute :parRliss='nonDebute' width=80 height=60></OnPlansNonDebute>
      </div>
      <div class="col-sm-3">
        <OnPlansStats :data='totaux'></OnPlansStats>
      </div>
    </div>
  </div>
</template>

<script>
import OnPlansNonDebute from '@/components/OnPlansNonDebute.vue';
import OnPlansStats from '@/components/OnPlansStats.vue';
import axios from 'axios';

// Import Loading and stylesheet
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data: function() {return {
    nonDebute: [],
    isLoading: true,
    totaux: {}
  }},

  name: 'OnPlansEnSouffrance',
  components: {
    Loading,
    OnPlansNonDebute,
    OnPlansStats
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/non_debute.php',
          { params: {}})
        .then(response => {
          this.nonDebute = response.data.non_debute;
          this.totaux = response.data.totaux;
          this.isLoading = false;
        })
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>
